// import webconfig from '../../../public/webconfig'
import Mock from 'mockjs'

(function () {
  // eslint-disable-next-line no-undef
  const mockUrl = webconfig.bis.api.mockUrl
  if (!mockUrl) return

  function buildRurl (url) {
    return new URL(url, mockUrl).href
  }

  Mock.mock(buildRurl('/authorize/login'), /post/i, {
    code: 200,
    message: null,
    data: {
      userId: '0',
      token: 'mock-token'
    }
  })

  Mock.mock(buildRurl('/authorize/this'), /get/i, {
    code: 200,
    message: null,
    data: {
      user: {
        id: '0',
        username: 'admin',
        name: '超级管理员'
      },
      terminal: {
        id: 666,
        name: '成分科电脑',
        namePy: 'CFK',
        ip: '127.0.0.1',
        mac: 'wqe-sdas-fadsfas',
        os: 'windows 10',
        loginUserId: 'admin',
        loginTime: '2021-02-07 11:13:20',
        remarks: '备注'
      }
    }
  })
})()
